import { ACTIVITY_TYPES_ENUMS } from "../system/globalEnums";

export const shopifyConstants = {
  ADD: "Add",
  OPTIONS_NAME: "OPTIONS_NAME",
  LINK_TO_SHOPIFY: "isLinkToShopify",
  USE_MARKET_PRICE: "useMarketPrice",
  SEPERATE_QUANTITY: "isOnlineQuantity",
  SHOPIFY_TEXT_FIELD: "SHOPIFY_TEXT_FIELD",
  NOTIFICATION_MODAL: "NOTIFICATION_MODAL",
  SHOPIFY_TAGS_FIELD: "SHOPIFY_TAGS_FIELD",
  SHOPIFY_COMBO_FIELD: "SHOPIFY_COMBO_FIELD",
  GET_SHOPIFY_PRESETS: "GET_SHOPIFY_PRESETS",
  SHOPIFY_NUMERIC_FIELD: "SHOPIFY_NUMERIC_FIELD",
  UPDATE_SHOPIFY_PRESET: "UPDATE_SHOPIFY_PRESET",
  CREATE_SHOPIFY_PRESET: "CREATE_SHOPIFY_PRESET",
  DELETE_SHOPIFY_PRESET: "DELETE_SHOPIFY_PRESET",
  SHOPIFY_SELECTION_FIELD: "SHOPIFY_SELECTION_FIELD",
  SHOPIFY_THEME_FIELD: "SHOPIFY_THEME_FIELD",
  IS_ONLINE_UNIT_SELL_PRICE: "isOnlineUnitSellPrice",
  GET_SHOPIFY_PRODUCT_TAGS: "GET_SHOPIFY_PRODUCT_TAGS",
  GET_SHOPIFY_THEME_TEMPLATES: "GET_SHOPIFY_THEME_TEMPLATES",
  SHOPIFY_WEIGHT_UNIT_FIELD: "SHOPIFY_WEIGHT_UNIT_FIELD",
  SHOPIFY_SALES_CHANNELS_FIELD: "SHOPIFY_SALES_CHANNELS_FIELD",
  GET_SHOPIFY_SALES_CHANNELS: "GET_SHOPIFY_SALES_CHANNELS",
  GET_SHOPIFY_PRESETS_BY_ID: "GET_SHOPIFY_PRESETS_BY_ID",
  SHOPIFY_NOT_EDITABLE_FIELD: "SHOPIFY_NOT_EDITABLE_FIELD",
  COMBO_BOX_INPUT_VALUE_IDENTIFIER: "COMBO_BOX_INPUT_VALUE",
  UPDATE_GLOBAL_SHOPIFY_PRESET: "UPDATE_GLOBAL_SHOPIFY_PRESET",
  SHOPIFY_COMPARE_AT_PRICE_FIELD: "SHOPIFY_COMPARE_AT_PRICE_FIELD",
  PRINT_ALL_SHOPIFY_ORDERS_SLIPS: "PRINT_ALL_SHOPIFY_ORDERS_SLIPS",
  GET_SHOPIFY_ORDER_NOTIFICATION_MODAL_DETAILS:
    "GET_SHOPIFY_ORDER_NOTIFICATION_MODAL_DETAILS",
  RESET_SHOPIFY_TO_EMPTY: "RESET_SHOPIFY_TO_EMPTY",
  SHOPIFY_INVENTORY_POLICY_FIELD: "SHOPIFY_INVENTORY_POLICY_FIELD",
  TOGGLE_SHOPIFY_ORDER_NOTIFICATION_MODAL:
    "TOGGLE_SHOPIFY_ORDER_NOTIFICATION_MODAL",
  SHOPIFY_TEXT_AREA_WITH_INSERT_VARIABLE_FIELD:
    "SHOPIFY_TEXT_AREA_WITH_INSERT_VARIABLE_FIELD",
  GET_SHOPIFY_ORDERS: "GET_SHOPIFY_ORDERS",
  ONLINE: "Online",
  PICKUP: "Pickup",
  HANDLE_MARK_ORDER_AS_FULFILLED: "handleMarkOrderAsFulfilled",
  HANDLE_MARK_ORDER_AS_READY: "handleMarkOrderAsReady",
  HANDLE_MARK_ORDER_AS_OPEN: "handleMarkOrderAsOpen",
  UPDATE_SHOPIFY_ORDER_STATUS: "UPDATE_SHOPIFY_ORDER_STATUS",
  POINT_OF_SALE: "Point of Sale",
  SHOPIFY_POS: "Shopify POS",
  PUBLICATION_POS_TITLE:
    "This sales channel controls whether a product is available on Shopify POS. It does not affect CollectPOS.",
  GET_ELIGIBLE_LOCATIONS: "GET_ELIGIBLE_LOCATIONS",
  GET_ELIGIBLE_SHOPIFY_LOCATIONS: "GET_ELIGIBLE_SHOPIFY_LOCATIONS",
  MIGRATE_SHOPIFY_LOCATION: "MIGRATE_SHOPIFY_LOCATION",
  LOCATION_FILTER: {
    CURRENT_LOCATION: "CURRENT_LOCATION",
    ALL_LOCATIONS: "ALL_LOCATIONS",
  },
  LOCATION_FILTER_OPTIONS: [
    {
      value: "CURRENT_LOCATION",
      label: "Current Location Orders",
    },
    {
      value: "ALL_LOCATIONS",
      label: "All Shopify Orders",
    },
  ],
  LOCATION_CONFIRMATION: {
    TITLE: "Location Confirmation",
    SINGLE_ORDER_MESSAGE:
      "This order contains items from a different Location than the one your Store is currently connected to. Do you wish to proceed?",
    BULK_ORDER_MESSAGE:
      "One or more of the selected orders contain items from a different Location than the one your Store is currently connected to. Do you wish to proceed with updating the status of the selected orders?",
  },
  CURRENT_LOCATION_LEGEND: "Blue Text = Items from current Location",
  CURRENT_LOCATION_TEXT_COLOR: "#0052cc",
  UNASSIGNED_LOCATION: "Unassigned Location",
  COMPANY_RESET_ADMIN_ONLY:
    "Only an Admin can reset the Shopify Configuration of a Company Store.",
  DISCONNECT_SHOPIFY_TO_CHANGE_COMPANY:
    "This store is connected to Shopify. Changing its company will disconnect Shopify, the store moves to the new company once Shopify is disconnected. Do you want to continue?",
  SHOPIFY_ORDER_STATUS: {
    PAID: "Paid",
    HOLD: "Hold",
    PENDING: "Pending",
    UNFULFILLED: "Unfulfilled",
    READY: "Ready",
    FULFILLED: "Fulfilled",
    // CANCELLED: "Cancelled",
    CANCELLED: "Refunded",
    PARTIAL_REFUNDED: "Partially Refunded",
    PARTIAL_FULFILLED: "Partially Fulfilled",
    REFUNDED: "Refunded",
    NEED_TRANSFER: "Need Transfer",
  },
  ORDERS_TYPES: [
    {
      value: ACTIVITY_TYPES_ENUMS.ALL,
      label: "All",
    },
    {
      value: ACTIVITY_TYPES_ENUMS.ONLINE,
      label: "Online",
    },
    {
      value: ACTIVITY_TYPES_ENUMS.PICKUP,
      label: "Pickup",
    },
  ],
  SHOPIFY_INVENTORY_POLICY_OPTIONS: [
    {
      value: "DENY",
      label: "Do not sell when out of stock",
    },
    {
      value: "CONTINUE",
      label: "Continue selling when out of stock",
    },
  ],
};

export const getShopifyOrderPaymentStatusOptions = () => {
  return [
    {
      value: ACTIVITY_TYPES_ENUMS.ALL,
      label: "All",
    },
    {
      value: shopifyConstants.SHOPIFY_ORDER_STATUS.PAID,
      label: shopifyConstants.SHOPIFY_ORDER_STATUS.PAID,
    },
    {
      value: shopifyConstants.SHOPIFY_ORDER_STATUS.REFUNDED,
      label: shopifyConstants.SHOPIFY_ORDER_STATUS.REFUNDED,
    },
    {
      value: shopifyConstants.SHOPIFY_ORDER_STATUS.PARTIAL_REFUNDED,
      label: shopifyConstants.SHOPIFY_ORDER_STATUS.PARTIAL_REFUNDED,
    },
  ];
};

export const getShopifyOrderFulfillmentStatusOptions = () => {
  return [
    {
      value: ACTIVITY_TYPES_ENUMS.ALL,
      label: "All",
    },
    {
      value: shopifyConstants.SHOPIFY_ORDER_STATUS.UNFULFILLED,
      label: shopifyConstants.SHOPIFY_ORDER_STATUS.UNFULFILLED,
    },
    {
      value: shopifyConstants.SHOPIFY_ORDER_STATUS.READY,
      label: shopifyConstants.SHOPIFY_ORDER_STATUS.READY,
    },
    {
      value: shopifyConstants.SHOPIFY_ORDER_STATUS.FULFILLED,
      label: shopifyConstants.SHOPIFY_ORDER_STATUS.FULFILLED,
    },
  ];
};

export const SHOPIFY_STATUS_OPTIONS = [
  {
    value: true,
    label: (
      <div className="d-flex align-items-center gap-3">
        Active <span className="shopify-statuc-dot"></span>
      </div>
    ),
  },
  {
    value: false,
    label: (
      <div className="d-flex align-items-center gap-3">
        Inactive{" "}
        <span className="shopify-statuc-dot shopify-statuc-dot-red"></span>
      </div>
    ),
  },
];

export const collectPosFields = [
  {
    value: "product_name",
    label: "Title",
  },
  {
    value: "description",
    label: "Description",
  },
  {
    value: "category_name",
    label: "Category",
  },
  {
    value: "subcategory",
    label: "Sub-Category",
  },
  {
    value: "sku",
    label: "SKU",
  },
  {
    value: "productType",
    label: "Type",
  },
  // {
  //   value: "upc",
  //   label: "UPC",
  // },
  {
    value: "tags",
    label: "Tags",
  },
  {
    value: "rarity",
    label: "Card Rarity",
  },
  {
    value: "cardNumber",
    label: "Card Number",
  },
  {
    value: "imgUrl",
    label: "Image",
  },
  {
    value: "tcgPlayerUrl",
    label: "Tcgplayer Url",
  },
  {
    value: "type",
    label: "Condition",
  },
  {
    value: "unit_purchase_price",
    label: "Cost of Goods",
  },
  {
    value: "unit_sell_price",
    label: "Unit Sell Price",
  },
  {
    value: "quantity",
    label: "Quantity",
  },
  {
    value: "marketPrice",
    label: "Market Price",
  },
  {
    value: "barcode",
    label: "Barcode",
  },
  {
    value: "language",
    label: "Language",
  },
  {
    value: "printing",
    label: "Printing",
  },
  {
    value: "set",
    label: "Set or Group",
  },
  {
    value: "grade",
    label: "Grade",
  },
];

export const SHOPIFY_OPTIONS_LIST = [
  {
    name: "optionName1",
    value: "optionValue1",
  },
  {
    name: "optionName2",
    value: "optionValue2",
  },
  {
    name: "optionName3",
    value: "optionValue3",
  },
];

export const shopifyPredefinedColumns = [
  {
    name: "title",
    label: "Title",
    type: shopifyConstants.SHOPIFY_COMBO_FIELD,
    required: true,
  },
  {
    name: "body_html",
    label: "Description",
    type: shopifyConstants.SHOPIFY_TEXT_AREA_WITH_INSERT_VARIABLE_FIELD,
    required: false,
  },
  {
    name: "shopifyTags",
    label: "Shopify Tags",
    type: shopifyConstants.SHOPIFY_TAGS_FIELD,
    required: false,
  },
  {
    name: "vendor",
    label: "Vendor",
    type: shopifyConstants.SHOPIFY_COMBO_FIELD,
    required: true,
  },
  {
    name: "product_type",
    label: "Product Type",
    type: shopifyConstants.SHOPIFY_COMBO_FIELD,
    required: true,
  },
  {
    name: "tags",
    label: "Tags",
    type: shopifyConstants.SHOPIFY_COMBO_FIELD,
    required: true,
  },
  {
    name: "published",
    label: "Publishing",
    type: shopifyConstants.SHOPIFY_SALES_CHANNELS_FIELD,
    required: false,
  },
  {
    name: "template_suffix",
    label: "Theme Template",
    type: shopifyConstants.SHOPIFY_THEME_FIELD,
  },
  {
    name: "sku",
    label: "SKU",
    type: shopifyConstants.SHOPIFY_COMBO_FIELD,
    required: true,
    isVarientField: true,
  },
  {
    name: "barcode",
    label: "Barcode",
    type: shopifyConstants.SHOPIFY_COMBO_FIELD,
    required: true,
    isVarientField: true,
  },
  {
    name: "compare_at_price",
    label: "Compare at Price",
    type: shopifyConstants.SHOPIFY_COMPARE_AT_PRICE_FIELD,
    required: false,
    isVarientField: true,
  },
  // {
  //   name: "grams",
  //   label: "Grams",
  //   type: shopifyConstants.SHOPIFY_NUMERIC_FIELD,
  //   required: false,
  //   isVarientField: true,
  // },
  {
    name: "weight",
    label: "Weight",
    type: shopifyConstants.SHOPIFY_NUMERIC_FIELD,
    required: false,
    isVarientField: true,
  },
  {
    name: "weight_unit",
    label: "Weight Unit",
    type: shopifyConstants.SHOPIFY_WEIGHT_UNIT_FIELD,
    required: false,
    isVarientField: true,
  },
  {
    name: "inventory_policy",
    label: "Inventory Policy",
    type: shopifyConstants.SHOPIFY_INVENTORY_POLICY_FIELD,
    required: false,
    isVarientField: true,
  },
  // {
  //   name: "fulfillment_service",
  //   label: "Fulfillment service",
  //   type: shopifyConstants.SHOPIFY_TEXT_FIELD,
  //   required: false,
  //   isVarientField: true,
  // },
  {
    name: "requires_shipping",
    label: "Requires shipping",
    type: shopifyConstants.SHOPIFY_SELECTION_FIELD,
    required: true,
    isVarientField: true,
  },
  {
    name: "taxable",
    label: "Taxable",
    type: shopifyConstants.SHOPIFY_SELECTION_FIELD,
    required: true,
    isVarientField: true,
  },
];

export const shopifySelectionOptions = [
  { label: "True", value: "true" },
  { label: "False", value: "false" },
];

export const defaultGlobalShopifyPresetObject = (currentStore) => {
  return {
    store: {
      id: currentStore?.id,
      name: currentStore?.storeName,
    },
    companyId: currentStore?.companyId,
    type: "GLOBAL",
    group: [],
    minPriceRange: -1,
    maxPriceRange: -2,
    shopifyMapping: {
      variantMapping: {
        inventory_quantity: 1,
        price: 0,
        position: 0,
      },
    },
  };
};

export const WEIGHT_UNIT_OPTIONS = [
  { label: "lb", value: "lb" },
  { label: "oz", value: "oz" },
  { label: "kg", value: "kg" },
  { label: "g", value: "g" },
];
